export const baseData = {
  error: false,
  loading: false,
};
